import { ChangeEvent, FC } from 'react';

import { CAMPAIGN_GENDERS, CampaignGender } from 'utils/constants/campaign';

import cpcFlexibleSexButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/cpc_flexible/cpc_flexible_sex_button_click';
import { Cell, CellText, Radio, VSpacingContainer } from '@hh.ru/magritte-ui';

import useOnOffState from 'hooks/common/useOnOffState';
import useTrls from 'hooks/translation/useTrls';
import useIsNewCampaign from 'utils/campaign/hooks/useIsNewCampaign';

import { MagritteFormField } from 'components/common/MagritteFormField/MagritteFormField';

import { setCampaignGender } from 'store/models/createCampaign';
import { selectMainMenuVacancyId } from 'store/models/mainMenu';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    label: 'AdCreate.AdForm.AdGender.legend',
    gender: {
        [CampaignGender.Male]: 'AdCreate.AdForm.AdGender.MALE',
        [CampaignGender.Female]: 'AdCreate.AdForm.AdGender.FEMALE',
        [CampaignGender.Any]: 'AdCreate.AdForm.AdGender.ANY',
    },
};

export const AdGender: FC = () => {
    const { adGender } = useSelector((state) => state.createCampaign);
    const vacancyId = useSelector(selectMainMenuVacancyId);
    const isCampaignProcessCreate = useIsNewCampaign();
    const [isTouched, setIsTouchedOn] = useOnOffState(false);

    const dispatch = useDispatch();
    const trl = useTrls();

    const setGender = (event: ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value as CampaignGender;
        if (!isTouched && isCampaignProcessCreate) {
            cpcFlexibleSexButtonClick({ vacancyId });
            setIsTouchedOn();
        }
        dispatch(setCampaignGender(value));
    };

    return (
        <MagritteFormField
            input={
                <VSpacingContainer default={12}>
                    {CAMPAIGN_GENDERS.map((gender) => (
                        <Cell
                            key={gender}
                            width="fit-content"
                            left={
                                <Radio
                                    value={gender}
                                    checked={adGender === gender}
                                    onChange={setGender}
                                    name="gender"
                                    data-qa={gender}
                                />
                            }
                        >
                            <CellText>{trl(TrlKeys.gender[gender])}</CellText>
                        </Cell>
                    ))}
                </VSpacingContainer>
            }
            label={trl(TrlKeys.label)}
            vSpacingBottom={32}
        />
    );
};
